import React, { useContext } from 'react';
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom';
import { auth } from '../config/firebasedeconfig';
import '../styles/components/rainDropAnimation.scss';

const RaindropAnimation = () => {

    const { username } = useContext(UserContext);
    const history = useNavigate();

    const goToProfile = () => {
        const userId = auth.currentUser?.uid;
        if (userId) {
            history(`/profilMemberPage/${userId}`);
        } else {
            history('/');
        }
    };


    return (
        <div className="container-scene">
            <div className="scene">
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="drop"></div>
                <div className="gradulationRegister">
                    <h3>FÉLICITATIONS !</h3>
                    <h4 className="username-dynamic">{username}</h4>
                    <h5>Votre compte a bien été enregistré.</h5>
                    <button onClick={goToProfile}>Voir mon profil</button>
                </div>
            </div>
        </div>
    );
};

export default RaindropAnimation;